module.exports = __webpack_public_path__ + "img/ic_googleplay_logo_w@2x.9464d756.png";